/* eslint-disable consistent-return */
import axios from 'axios'
import { AllowedHttpMethods, authenticationApiConfig } from '../apiList'
import { getAuthenticatedRequestConfig } from '../../../utils/apiUtils'

export type IsVendorAvailable = {
  isVendorAvailable: boolean
}

const authenticateVendor = async (
  username: string,
  newPassword: string,
  // tenantKey: string,
): Promise<{ isVendorAvailable: IsVendorAvailable } | undefined> => {
  try {
    //const encodedCredentials = encode(`${username}:${newPassword}`)

    const requestConfig = getAuthenticatedRequestConfig({
      url: authenticationApiConfig.vendorUpdatePassword,
      method: AllowedHttpMethods.put,
      params: {
        userName: username,
        newPassword,
      },
      // additionalHeaders: {
      //   Authorization: `Basic ${encodedCredentials}`,
      // },
      // tenantKey,
    })

    const response = await axios(requestConfig)
    return {
      isVendorAvailable: response.data?.isVendorAvailable ?? false,
    }
  } catch (error) {
    console.error('Error authenticating user:', error)
    return undefined
  }
}

const vendorResetApi = { authenticateVendor }

export default vendorResetApi
